import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/delivery-order',
    params: params,
  })

  return response?.data
}

const _getIndex = async (queryParamFilters, queryParam) => {
  const data = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/delivery-order/index',
    data: data,
  })

  return response?.data
}

const _update = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: '/delivery-order/update',
    data: data,
  })

  return response?.data
}

export const get =
  (queryParamFilters) => async (queryParam) =>
    await _get(queryParamFilters, queryParam)

export const getIndex =
  (queryParamFilters) => async (queryParam) =>
    await _getIndex(queryParamFilters, queryParam)

export const update = async (data) => await _update(data)
